import { put } from 'redux-saga/effects';
import AccessLevelsActions from '../redux/AccessLevelsRedux';
import i18n from '../i18n';

export function* getAccessLevels(api, { customerId, pageParams }) {
  try {
    const getAccessLevelsResponse = yield api.getAccessLevels(customerId, pageParams);
    if (getAccessLevelsResponse.ok) {
      yield put(
        AccessLevelsActions.getAccessLevelsRequestSuccess(
          getAccessLevelsResponse.data.content,
          getAccessLevelsResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getAccessLevelsResponse);
      const error =
        typeof getAccessLevelsResponse.problem !== 'undefined'
          ? getAccessLevelsResponse.problem
          : typeof getAccessLevelsResponse.data.error !== 'undefined'
          ? i18n.t(getAccessLevelsResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.getAccessLevelsRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevels saga', error);
    yield put(AccessLevelsActions.getAccessLevelsRequestFailure(error));
  }
}

export function* createAccessLevel(api, { accessLevelInfos, customerId, pageParams }) {
  try {
    const createAccessLevelResponse = yield api.createAccessLevel(accessLevelInfos);
    const getAccessLevelsResponse = yield api.getAccessLevels(customerId, pageParams);
    const successMessage = i18n.t('successMessage.createAccessLevelSuccess');
    if (createAccessLevelResponse.ok && getAccessLevelsResponse.ok) {
      yield put(
        AccessLevelsActions.createAccessLevelRequestSuccess(
          createAccessLevelResponse.data.accessLevelId,
          getAccessLevelsResponse.data.content,
          getAccessLevelsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createAccessLevelResponse);
      api.checkAuth(getAccessLevelsResponse);
      const error =
        typeof createAccessLevelResponse.problem !== 'undefined'
          ? createAccessLevelResponse.problem
          : typeof createAccessLevelResponse.data.error !== 'undefined'
          ? i18n.t(createAccessLevelResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.createAccessLevelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevel saga', error);
    yield put(AccessLevelsActions.createAccessLevelRequestFailure(error));
  }
}

export function* editAccessLevel(api, { accessLevelInfos, customerId, pageParams }) {
  try {
    const editAccessLevelResponse = yield api.editAccessLevel(accessLevelInfos);
    const getAccessLevelsResponse = yield api.getAccessLevels(customerId, pageParams);
    const successMessage = i18n.t('successMessage.editAccessLevelSuccess');
    if (editAccessLevelResponse.ok && getAccessLevelsResponse.ok) {
      yield put(
        AccessLevelsActions.editAccessLevelRequestSuccess(
          getAccessLevelsResponse.data.content,
          getAccessLevelsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editAccessLevelResponse);
      api.checkAuth(getAccessLevelsResponse);
      const error =
        typeof editAccessLevelResponse.problem !== 'undefined'
          ? editAccessLevelResponse.problem
          : typeof editAccessLevelResponse.data.error !== 'undefined'
          ? i18n.t(editAccessLevelResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.editAccessLevelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevel saga', error);
    yield put(AccessLevelsActions.editAccessLevelRequestFailure(error));
  }
}

export function* deleteAccessLevel(api, { accessLevelId, customerId, pageParams }) {
  try {
    const deleteAccessLevelResponse = yield api.deleteAccessLevel(accessLevelId);
    const getAccessLevelsResponse = yield api.getAccessLevels(customerId, pageParams);
    const successMessage = i18n.t('successMessage.deleteAccessLevelSuccess');
    if (deleteAccessLevelResponse.ok && getAccessLevelsResponse.ok) {
      yield put(
        AccessLevelsActions.deleteAccessLevelRequestSuccess(
          getAccessLevelsResponse.data.content,
          getAccessLevelsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteAccessLevelResponse);
      api.checkAuth(getAccessLevelsResponse);
      const error =
        typeof deleteAccessLevelResponse.problem !== 'undefined'
          ? deleteAccessLevelResponse.problem
          : typeof deleteAccessLevelResponse.data.error !== 'undefined'
          ? i18n.t(deleteAccessLevelResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.deleteAccessLevelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevel saga', error);
    yield put(AccessLevelsActions.deleteAccessLevelRequestFailure(error));
  }
}

export function* getAccessLevelControllers(api, { accessLevelId }) {
  try {
    const getAccessLevelControllersResponse = yield api.getAccessLevelControllers(accessLevelId);
    if (getAccessLevelControllersResponse.ok) {
      yield put(AccessLevelsActions.getAccessLevelControllersRequestSuccess(getAccessLevelControllersResponse.data));
    } else {
      api.checkAuth(getAccessLevelControllersResponse);
      const error =
        typeof getAccessLevelControllersResponse.problem !== 'undefined'
          ? getAccessLevelControllersResponse.problem
          : typeof getAccessLevelControllersResponse.data.error !== 'undefined'
          ? i18n.t(getAccessLevelControllersResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.getAccessLevelControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevels saga', error);
    yield put(AccessLevelsActions.getAccessLevelControllersRequestFailure(error));
  }
}

export function* getMultipleAccessLevelControllers(api, { accessLevelIds }) {
  put(AccessLevelsActions.getMultipleAccessLevelControllersRequest());
  try {
    let combinedAccessLevels = [];
    let combinedControllers = [];
    for (let accessLevelId of accessLevelIds) {
      const getAccessLevelControllersResponse = yield api.getAccessLevelControllers(accessLevelId);
      if (getAccessLevelControllersResponse.ok) {
        yield combinedAccessLevels.push({
          accessLevelId: accessLevelId,
          controllers: getAccessLevelControllersResponse.data,
        });
        yield (combinedControllers = combinedControllers.concat(getAccessLevelControllersResponse.data));
      } else {
        const error =
          typeof getAccessLevelControllersResponse.problem !== 'undefined'
            ? getAccessLevelControllersResponse.problem
            : typeof getAccessLevelControllersResponse.data.error !== 'undefined'
            ? i18n.t(getAccessLevelControllersResponse.data.error)
            : i18n.t('unexpectedError');
        yield put(AccessLevelsActions.getMultipleAccessLevelControllersRequestFailure(error));
      }
    }
    const hasDuplicates =
      new Set(combinedControllers.map((item) => item['controllerId'])).size !== combinedControllers.length;
    yield put(AccessLevelsActions.getMultipleAccessLevelControllersRequestSuccess(combinedAccessLevels, hasDuplicates));
  } catch (error) {
    console.log('error in AccessLevels saga', error);
    yield put(AccessLevelsActions.getMultipleAccessLevelControllersRequestFailure(error));
  }
}

export function* addControllersToAccessLevel(api, { accessLevelId, controllers }) {
  try {
    const addControllersToAccessLevelResponse = yield api.addControllersToAccessLevel(accessLevelId, controllers);
    const getAccessLevelControllersResponse = yield api.getAccessLevelControllers(accessLevelId);
    const successMessage = i18n.t('successMessage.addDoor');
    if (addControllersToAccessLevelResponse.ok && getAccessLevelControllersResponse.ok) {
      yield put(
        AccessLevelsActions.addControllersToAccessLevelRequestSuccess(
          getAccessLevelControllersResponse.data,
          successMessage
        )
      );
    } else {
      api.checkAuth(addControllersToAccessLevelResponse);
      api.checkAuth(getAccessLevelControllersResponse);
      const error =
        typeof addControllersToAccessLevelResponse.problem !== 'undefined'
          ? addControllersToAccessLevelResponse.problem
          : typeof addControllersToAccessLevelResponse.data.error !== 'undefined'
          ? i18n.t(addControllersToAccessLevelResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.addControllersToAccessLevelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevels saga', error);
    yield put(AccessLevelsActions.addControllersToAccessLevelRequestFailure(error));
  }
}

export function* deleteAccessLevelControllers(api, { accessLevelId, controllers }) {
  try {
    const deleteAccessLevelControllersResponse = yield api.deleteAccessLevelControllers(accessLevelId, controllers);
    const getAccessLevelControllersResponse = yield api.getAccessLevelControllers(accessLevelId);
    const successMessage = i18n.t('successMessage.deleteDoor');
    if (deleteAccessLevelControllersResponse.ok && getAccessLevelControllersResponse.ok) {
      yield put(
        AccessLevelsActions.deleteAccessLevelControllersRequestSuccess(
          getAccessLevelControllersResponse.data,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteAccessLevelControllersResponse);
      api.checkAuth(getAccessLevelControllersResponse);
      const error =
        typeof deleteAccessLevelControllersResponse.problem !== 'undefined'
          ? deleteAccessLevelControllersResponse.problem
          : typeof deleteAccessLevelControllersResponse.data.error !== 'undefined'
          ? i18n.t(deleteAccessLevelControllersResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AccessLevelsActions.deleteAccessLevelControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AccessLevels saga', error);
    yield put(AccessLevelsActions.deleteAccessLevelControllersRequestFailure(error));
  }
}
